import { CellText } from "assets/js/Styles";
import CustomCheckbox from "components/customs/checkbox";
import FormGenerator from "components/customs/form-generator/input";
import { ADD_ACTION, EDIT_ACTION } from "constants/actions";
import React from "react";
import { Check } from "react-feather";
import { UncontrolledTooltip } from "reactstrap";
import styled from "styled-components";
import { getTooltipText } from "./utility";

const CheckboxContainer = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledFormGenerator = styled(FormGenerator)`
  background: ${({ theme }) => theme.colors.white};
  height: unset;
  border-radius: 0;
  padding: 2px 10px !important;

  &[inputmode="numeric"] {
    height: 34px;
  }
`;

const addTVISettingsColumns = ({
  courses,
  action,
  originalCapacityMap,
  toggleCourseSelection,
  updateAbscap,
}) => {
  return [
    {
      name: "",
      selector: (record) => record.id,
      sortable: false,
      width: "60px",
      cell: (record) => {
        const isChecked = courses?.some(
          (course) => course.courseId === record.courseId
        );

        const wasOriginallyChecked =
          action === EDIT_ACTION &&
          (originalCapacityMap.current[record.courseId]?.capacity ?? 0) > 0;

        const maxSlots =
          action === ADD_ACTION
            ? record.availableSlots
            : Number(
                originalCapacityMap.current[record.courseId]?.capacity ?? 0
              ) + Number(record?.availableSlots ?? 0);

        const disabled =
          (action === ADD_ACTION && maxSlots <= 0) ||
          (action === EDIT_ACTION && !wasOriginallyChecked && maxSlots <= 0);

        return (
          <CheckboxContainer>
            <CustomCheckbox
              onChange={(evt) =>
                toggleCourseSelection(record, evt.target.checked)
              }
              disabled={disabled || record.isFull || record.hasEndorsements}
              icon={<Check size={16} />}
              checked={isChecked}
            />
          </CheckboxContainer>
        );
      },
    },
    {
      name: "Course",
      selector: (row) => row?.course,
      grow: 2,
      sortable: true,
      cell: ({ course }) => <CellText>{course}</CellText>,
    },
    {
      name: "Course Code",
      selector: null,
      sortable: false,
      cell: ({ courseCode }) => <CellText>{courseCode}</CellText>,
    },
    {
      name: "Sector",
      selector: (row) => row?.sector,
      sortable: true,
      cell: ({ sector }) => <CellText>{sector}</CellText>,
    },
    {
      name: "Available Slots",
      selector: (record) => {
        const original = originalCapacityMap.current?.[record.courseId];

        return original?.availableSlots ?? record.availableSlots;
      },
      sortable: true,
      cell: ({ availableSlots }) => <CellText>{availableSlots}</CellText>,
    },
    {
      name: "ABSCAP",
      selector: (row) => row?.abscap,
      sortable: true,
      cell: (record) => {
        const course = courses?.find((crs) => crs.courseId === record.courseId);
        const isChecked = Boolean(course);
        const abscap = isChecked ? Number(course.capacity) : 0;

        const originalCapacity = Number(
          originalCapacityMap.current[record.courseId]?.capacity ?? 0
        );
        const availableSlots = Number(record?.availableSlots ?? 0);

        const wasOriginallyChecked =
          action === EDIT_ACTION && originalCapacity > 0;

        const maxCapacity =
          action === ADD_ACTION
            ? availableSlots
            : originalCapacity + availableSlots;

        const isAddDisabled = action === ADD_ACTION && maxCapacity <= 0;

        const isEditDisabled =
          action === EDIT_ACTION && !wasOriginallyChecked && maxCapacity <= 0;
        const disabled = isAddDisabled || isEditDisabled || record.isFull;

        const exceedsCapacity = abscap > maxCapacity;

        const hasEndorsementsConflict =
          record.hasEndorsements && abscap < originalCapacity;

        const showValidation = exceedsCapacity || hasEndorsementsConflict;

        const tooltipMessage = getTooltipText(
          hasEndorsementsConflict,
          exceedsCapacity
        );

        return (
          <>
            <StyledFormGenerator
              id={`slot-input-${record.courseCapacityId}`}
              type="text"
              className={`${showValidation ? "form-control is-invalid" : ""}`}
              value={isChecked ? course.capacity : ""}
              disabled={!isChecked || disabled}
              onChange={(event) =>
                updateAbscap(record.courseId, event.target.value)
              }
            />
            {showValidation && (
              <UncontrolledTooltip
                placement="top"
                target={`slot-input-${record.courseCapacityId}`}
              >
                {tooltipMessage}
              </UncontrolledTooltip>
            )}
          </>
        );
      },
    },
  ];
};

export default addTVISettingsColumns;
